export enum KnownProduct {
  FPS = "Norma-platform",
  Akidemy = "Akidemy",
  Lil = "Lil",
  Bye = "Bye",
  CvWow = "Cvwow",
  Yay = "Yay",
}
